// This import loads the firebase namespace along with all its type information.
import Feedback from './feedback-model'

export async function load_feedbacks(): Promise<Feedback[]> {
  throw 'Not implemented'
}

export async function delete_feedback(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_feedback(): Promise<Feedback> {
  throw 'Not implemented'
}
